import { ChevronRight, CheckCircle2, CircleAlert } from "lucide-react";
import { sectionStats } from "./wizardStatus";

// Übersicht: Gesamt-% + pro Abschnitt Ampel + offene Punkte zum Anspringen.
export default function WizardOverview({ steps, doc, overall, onJump }) {
  return (
    <div className="space-y-4" data-testid="wizard-overview">
      <div className={`rounded-2xl border p-4 ${overall.open === 0 ? "border-emerald-500/50 bg-emerald-500/[0.06]" : "border-red-500/40 bg-red-500/[0.05]"}`}>
        <div className="flex items-end justify-between gap-3">
          <div>
            <div className="text-[12px] uppercase tracking-wider font-semibold text-zinc-400">Gesamtfortschritt</div>
            <div className="text-4xl font-bold text-zinc-50 tabular-nums" data-testid="wizard-overview-pct">{overall.pct} %</div>
          </div>
          <div className="text-right text-[13px]">
            <div className="text-emerald-300 font-semibold">{overall.done} erledigt</div>
            <div className={overall.open ? "text-red-300 font-semibold" : "text-zinc-500"} data-testid="wizard-overview-open">{overall.open} offen</div>
          </div>
        </div>
        <ProgressBar pct={overall.pct} className="mt-3 h-3" />
      </div>

      <div className="space-y-2">
        {steps.map((sec, i) => {
          const st = sectionStats(sec, doc);
          const ok = st.open === 0;
          return (
            <div key={sec.section} className={`rounded-xl border ${ok ? "border-emerald-500/30" : "border-red-500/40"} bg-[#101015]`}>
              <button type="button" onClick={() => onJump(i)} data-testid={`wizard-overview-sec-${sec.section}`}
                      className="w-full flex items-center gap-3 p-3 text-left">
                <span className={`h-9 min-w-[36px] px-1.5 rounded-lg flex items-center justify-center text-[12px] font-bold font-mono ${ok ? "bg-emerald-500 text-zinc-950" : "bg-red-500/20 text-red-300 border border-red-500/50"}`}>
                  {ok ? <CheckCircle2 size={16} /> : sec.section}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-[14px] font-semibold text-zinc-100 truncate">{sec.title}</span>
                  <span className="block mt-1"><ProgressBar pct={st.pct} className="h-1.5" /></span>
                </span>
                <span className={`text-[12px] font-mono tabular-nums ${ok ? "text-emerald-300" : "text-red-300"}`}>{st.done}/{st.total}</span>
                <ChevronRight size={16} className="text-zinc-500" />
              </button>
              {st.openFields.length > 0 && (
                <div className="px-3 pb-3 flex flex-wrap gap-1.5">
                  {st.openFields.map((f) => (
                    <button key={f.key} type="button" onClick={() => onJump(i, f.key)}
                            data-testid={`wizard-overview-open-${f.key}`}
                            className="h-8 px-2.5 rounded-lg bg-red-500/10 border border-red-500/30 text-red-200 text-[12px] inline-flex items-center gap-1">
                      <CircleAlert size={12} /> {f.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function ProgressBar({ pct, className = "h-2" }) {
  return (
    <div className={`w-full rounded-full overflow-hidden bg-red-500/25 ${className}`}>
      <div className="h-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${pct}%` }} />
    </div>
  );
}
